<template>
  <div :style="{ color: color, fontWeight: fontWeight, fontSize: fontSize }">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'LayoutTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#059347',
    },
    fontWeight: {
      type: Number,
      default: 700,
    },
    fontSize: {
      type: String,
      default: '20px',
    },
  },
}
</script>
